<template>
  <div>
    <!-- 大象用户id:{{ user_id }} -->
    <div v-if="is_dingding">
      <div v-if="!is_bind">
        <div class="dingding_div">
          <div class="dingding_img">
            <img
              style="width: 100%; height: 100%"
              src="@/assets/image/auth/dingding_logo.png"
              alt=""
            />
          </div>
        </div>
        <div class="dingding_div2"><span class="bdtitle">大象绑定中..</span></div>
      </div>
      <div v-else>
        <div class="dingding_div">
          <span class="iconfont iconbangding"></span>
        </div>
        <div class="dingding_div2">
          <span class="bdtitle">钉钉绑定完成，关闭页面即可</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="not_dingding">请使用【钉钉】app扫一扫进行绑定</div>
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi"; // 此方式为整体加载，也可按需进行加载
import { http, open_new_page } from "@/utils/http.js";

export default {
  data() {
    return {
      dd_data: {},
      user_id: "",
      is_bind: false,
      is_dingding: false,
    };
  },

  created() {},

  mounted() {
    var query = this.$route.query;
    this.user_id = query.user_id;
    if (this.user_id == undefined || this.user_id == "") {
      alert("没有大象用户id");
      return;
    }
    this.is_dingding = this.isDingTalkEnvironment();

    if (this.is_dingding) {
      this.get_args();
    }
  },
  methods: {
    isDingTalkEnvironment() {
      return /dingtalk/i.test(navigator.userAgent);
    },

    get_args() {
      var that = this;
      var obj = {
        key: "123",
        href: location.href,
      };
      http("post", process.env.VUE_APP_HOST + "/api_export/dingding/get_ak", obj, false)
        .then((res) => {
          console.log(res);
          that.dd_data = res.data;

          dd.config(res.data);

          dd.error(function (err) {
            alert("dd error: " + JSON.stringify(err));
          }); //该方

          dd.getAuthCode({
            corpId: res.data.corpId,
            success: (res) => {
              console.log(res);
              that.get_userinfo(res.code);
            },
            fail: () => {},
            complete: () => {},
          });
        })
        .catch((res) => {
          that.admin_login_loading = false;
          console.log(res, "请求出错");
        });
    },

    get_userinfo(code) {
      var obj = {
        code: code,
        user_id: this.user_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/api_export/dingding/get_userinfo",
        obj,
        false
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.is_bind = true;
            dd.showToast({
              type: "success",
              content: res.msg,
              duration: 4000,
              success: () => {},
              fail: () => {},
              complete: () => {},
            });
          } else {
            dd.showToast({
              type: "error",
              content: res.msg,
              duration: 4000,
              success: () => {},
              fail: () => {},
              complete: () => {},
            });
          }
        })
        .catch((res) => {
          that.admin_login_loading = false;
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.not_dingding {
  padding: 40px 20px;
  background: red;
  display: flex;
  color: #fff;
  justify-content: center;
}

.bdtitle {
  margin-top: 10px;
  letter-spacing: 1px;
}

.iconbangding {
  font-size: 80px;
  color: #0466dd;
}

.dingding_div {
  margin-top: 30vh;
  display: flex;
  justify-content: center;
}

.dingding_div2 {
  display: flex;
  justify-content: center;
}

.dingding_img {
  width: 70px;
  height: 70px;
}
</style>
